import { navItems } from "@/mocks/home";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-primary-900 text-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="lg:w-1/3">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg bg-background-50/10 border border-background-50/20 flex items-center justify-center">
                <i className="ri-book-marked-line text-lg text-accent-300"></i>
              </span>
              <strong className="font-heading text-lg font-bold">善良的女秘书</strong>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-50/75">
              一个围绕「善良的女秘书」关键词的资源渠道查询导航页，整理百度云、网盘资源、迅雷下载、磁力链接、种子资源与阿里云盘
              的查询思路与使用注意事项。
            </p>
          </div>

          <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-6">
            <div>
              <h4 className="font-heading text-sm font-bold text-accent-200">页面导航</h4>
              <ul className="mt-3 space-y-2">
                {navItems.slice(0, 4).map((item) => (
                  <li key={item.id}>
                    <a href={`#${item.id}`} className="text-sm text-background-50/75 hover:text-background-50">
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="font-heading text-sm font-bold text-accent-200">继续了解</h4>
              <ul className="mt-3 space-y-2">
                {navItems.slice(4).map((item) => (
                  <li key={item.id}>
                    <a href={`#${item.id}`} className="text-sm text-background-50/75 hover:text-background-50">
                      {item.label}
                    </a>
                  </li>
                ))}
                <li>
                  <a href="#tags" className="text-sm text-background-50/75 hover:text-background-50">
                    相关搜索
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-span-2 sm:col-span-1">
              <h4 className="font-heading text-sm font-bold text-accent-200">合规提示</h4>
              <p className="mt-3 text-sm leading-relaxed text-background-50/75">
                本站不提供、不托管任何受版权保护的作品文件，仅整理公开的检索思路与渠道说明。请通过合法渠道获取内容。
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-50/60">
            © {year} 善良的女秘书 · 资源渠道查询导航。内容仅供信息参考。
          </p>
          <p className="text-xs text-background-50/60 flex items-center gap-1.5">
            <i className="ri-shield-check-line"></i>
            请遵守所在地区法律法规与平台用户协议
          </p>
        </div>
      </div>
    </footer>
  );
}